import React from 'react';
import PropTypes from 'prop-types';

const ItemWrapper = ({children}) => {
  return (
    <div className="list-group-item">
      {children}
    </div>
  );
};

ItemWrapper.propTypes = {
  children: PropTypes.node.isRequired
};

export default ItemWrapper;
